import { useQuery } from "@tanstack/react-query";
import { getSupabase } from "@/lib/hooks/api/utils";

export function useContactMeetings(params?: {
  page?: number;
  limit?: number;
  search?: string;
  contact_id?: string;
  status?: string;
  meeting_type?: string;
}) {
  return useQuery({
    queryKey: ["contact-meetings", params],
    queryFn: async () => {
      const supabase = getSupabase();
      let query = supabase.from("contact_meetings").select(`
                    *,
                    contacts:contact_id (
                        id,
                        name,
                        company_name,
                        email
                    ),
                    users:app_users(
                        id,
                        first_name,
                        last_name,
                        email
                    )
                `);

      if (params?.contact_id) {
        query = query.eq("contact_id", params.contact_id);
      }
      if (params?.status) {
        query = query.eq("status", params.status);
      }
      if (params?.meeting_type) {
        query = query.eq("meeting_type", params.meeting_type);
      }
      if (params?.search) {
        query = query.or(`title.ilike.%${params.search}%,description.ilike.%${params.search}%`);
      }

      if (params?.limit) {
        const offset = (params.page || 0) * params.limit;
        query = query.range(offset, offset + params.limit - 1);
      }

      const { data, error } = await query.order("start_time", { ascending: false });

      if (error) {
        console.error("Error fetching contact meetings:", error);
        throw new Error(error.message);
      }

      return data || [];
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function useContactMeeting(id: string) {
  return useQuery({
    queryKey: ["contact-meetings", id],
    queryFn: async () => {
      const supabase = getSupabase();
      const { data, error } = await supabase
        .from("contact_meetings")
        .select(`
                    *,
                    contacts:contact_id (
                        id,
                        name,
                        company_name,
                        email
                    ),
                    users:app_users(
                        id,
                        first_name,
                        last_name,
                        email
                    )
                `)
        .eq("id", id)
        .single();

      if (error) {
        console.error("Error fetching contact meeting:", error);
        throw new Error(error.message);
      }

      return data;
    },
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
  });
}
